// Mantido por compatibilidade: o seletor único agora é components/EscolherIcone.tsx (com busca por nome).
// Lembrete: monte o seletor DENTRO da folha (Sheet) de onde ele é aberto — veja a explicação lá.
export { EscolherIcone as EmojiPicker, CampoIcone } from './EscolherIcone';
